import React from 'react';
import AnimatedSection from './AnimatedSection';
import StaggeredList from './StaggeredList';
import { TrendingUp, Clock, Heart, Activity } from 'lucide-react';

const EarlyMobilitySection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <AnimatedSection animation="fade-up">
          <div className="max-w-6xl mx-auto">
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              <div className="order-2 lg:order-1 rounded-xl overflow-hidden shadow-xl">
                <img
                  src="/images/nurses-patients/nurse-and-patient1.png"
                  alt="Nurse caring for patient with organized medical lines"
                  className="w-full h-full object-cover"
                />
              </div>

              <div className="order-1 lg:order-2">
                <h2 className="text-4xl font-bold mb-6" style={{ color: '#214140' }}>
                  Support Early Mobility
                </h2>
                <p className="text-xl text-gray-600 mb-8">
                  A published cost model projected that ICU early mobility programs save about $818,000 a year, and up to $3.76 million in its best case (Lord et al., 2013). Systematic early mobilization shortened ICU stays by about 2 days in ventilated adults (Wang et al., 2023). Line clutter is one barrier to getting patients moving; Cordflex keeps those lines organized.
                </p>

                <StaggeredList delay={120} className="space-y-6">
                  <div className="rounded-lg p-6 border-l-4" style={{ backgroundColor: '#DFEAF0', borderColor: '#1F8051' }}>
                    <div className="flex items-start space-x-4">
                      <TrendingUp className="h-8 w-8 flex-shrink-0 mt-1" style={{ color: '#1F8051' }} />
                      <div>
                        <h3 className="text-xl font-bold mb-2" style={{ color: '#214140' }}>74% of Nurses Would Feel Safer</h3>
                        <p className="text-gray-700">
                          In an internal survey, 74% of surveyed nurses said they would feel safer ambulating patients with Cordflex
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="rounded-lg p-6 border-l-4" style={{ backgroundColor: '#DFEAF0', borderColor: '#8BBAB8' }}>
                    <div className="flex items-start space-x-4">
                      <Clock className="h-8 w-8 flex-shrink-0 mt-1" style={{ color: '#8BBAB8' }} />
                      <div>
                        <h3 className="text-xl font-bold mb-2" style={{ color: '#214140' }}>Less Time Managing Lines</h3>
                        <p className="text-gray-700">
                          ICU staff spend about 61% of each early-mobility session managing tubes and lines (Benjamin et al., 2022). Cordflex is a line-management device designed to keep lines organized and ready to move.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="rounded-lg p-6 border-l-4" style={{ backgroundColor: '#DFEAF0', borderColor: '#214140' }}>
                    <div className="flex items-start space-x-4">
                      <Heart className="h-8 w-8 flex-shrink-0 mt-1" style={{ color: '#214140' }} />
                      <div>
                        <h3 className="text-xl font-bold mb-2" style={{ color: '#214140' }}>Why Early Mobility Matters</h3>
                        <p className="text-gray-700">
                          Published research links early mobility to shorter stays and better recovery, and line clutter is a known barrier. Line-organizing devices have been shown to cut the time needed to arrange IV lines for patient transport (Joo et al., 2016).
                        </p>
                      </div>
                    </div>
                  </div>
                </StaggeredList>
              </div>
            </div>
          </div>
        </AnimatedSection>
      </div>
    </section>
  );
};

export default EarlyMobilitySection;
